import clsx from 'clsx';
import type { ReactNode } from 'react';

export function FormGroup({
  label,
  required,
  error,
  children,
  className,
  hint,
}: {
  label: ReactNode;
  required?: boolean;
  error?: string | null;
  hint?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={clsx('flex flex-col gap-1 sm:gap-1.5', className)}>
      <label className="text-[10px] font-bold uppercase tracking-wide text-[var(--text-secondary)] sm:text-[11px]">
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>
      {children}
      {hint && !error && (
        <div className="text-[10px] text-[var(--text-muted)] sm:text-[11px]">{hint}</div>
      )}
      {error && <div className="text-[10px] text-danger sm:text-[11px]">{error}</div>}
    </div>
  );
}

export function FormSection({ title, children }: { title: ReactNode; children: ReactNode }) {
  return (
    <div className="mb-3 sm:mb-5">
      <div className="mb-2 border-b border-[var(--border-color)] pb-1 text-[10px] font-extrabold uppercase tracking-widest text-accent sm:mb-3 sm:pb-1.5 sm:text-[11px]">
        {title}
      </div>
      {children}
    </div>
  );
}
